function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M40,22.55l4.16,8.86,1.36,2.9,3.17.48,9.49,1.45-7.05,7.23-2.11,2.17.49,2.99,1.65,10.08-8.24-4.56-2.9-1.6-2.9,1.6-8.24,4.56,1.65-10.08.49-2.99-2.11-2.17-7.05-7.23,9.49-1.45,3.17-.48,1.36-2.9,4.16-8.86M40,13.01c-1.31,0-2.5.76-3.06,1.94l-6.53,13.92-14.55,2.22c-1.25.19-2.29,1.06-2.69,2.26-.4,1.2-.1,2.52.79,3.43l10.62,10.89-2.52,15.41c-.21,1.28.33,2.56,1.39,3.3.58.41,1.26.62,1.94.62.56,0,1.13-.14,1.64-.42l12.97-7.17,12.97,7.17c.51.28,1.07.42,1.64.42.68,0,1.36-.21,1.94-.62,1.06-.74,1.6-2.03,1.39-3.3l-2.52-15.41,10.62-10.89c.88-.91,1.19-2.23.78-3.43h.01c-.4-1.2-1.44-2.07-2.69-2.26l-14.55-2.22-6.53-13.92c-.56-1.19-1.75-1.94-3.06-1.94h0Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Newest-inactive.8a819be9.svg";
export { SvgComponent as ReactComponent };